import { render, staticRenderFns } from "./UnitGeoMoveModal.vue?vue&type=template&id=cfd2ff68&"
import script from "./UnitGeoMoveModal.vue?vue&type=script&lang=js&"
export * from "./UnitGeoMoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports